enum Mutations {
  OPEN_POSITION = 'openPosition',
  CLOSE_POSITION = 'closePosition',
}

export default Mutations;
